<span class="table-search-wrapper ">
  <input kendoTextBox placeholder="Search" class="filter-box" [(ngModel)]="filter_string" (keypress)="keyPressed($event)" (click)="$event.stopPropagation()" />
    <button kendoButton [svgIcon]="filterIcon" (click)="filterTable()">Filter Results</button>
    <button kendoButton (click)="clearFilters()" [disabled]="!(state.filter?.filters?.length > 0)">Clear</button>
  </span>